import { BonusClassification } from '@synergy/models';

const translationObject: { [Key in BonusClassification]: string } = {
    [BonusClassification.Bonus]: 'app.select.option.bonus',
    [BonusClassification.BonusPlus]: 'app.select.option.bonusPlus',
    [BonusClassification.Contract]: 'app.select.option.contract',
};

export const getBonusClassificationTranslationId = (status: BonusClassification): string => {
    return (status && translationObject[status]) || '';
};
